import React from 'react';
import { Users, Building2, Lock, ShieldAlert } from 'lucide-react';

// Map icon names from constants to Lucide icon components
const iconMap = {
  Users,
  Building2,
  Lock,
  ShieldAlert,
};

const ManualEvidenceAreaCard = ({ area, totalTasks, completedTasks, onUploadClick }) => {
  const Icon = iconMap[area.icon] || Users;
  const progressPercentage = totalTasks > 0 ? (completedTasks / totalTasks) * 100 : 0;

  return (
    <div className="bg-white rounded-lg border border-gray-200 border-l-4 border-l-blue-500 p-6">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon className="w-6 h-6 text-blue-600" />
        </div>

        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-2">
            <h3 className="text-lg font-semibold text-gray-900">{area.name}</h3>
            <span className="text-sm text-gray-600">
              {completedTasks} of {totalTasks} completed
            </span>
          </div>

          <p className="text-sm text-gray-600 mb-4">{area.description}</p>

          {/* Progress bar */}
          <div className="mb-4">
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-blue-500 h-2 rounded-full transition-all duration-300"
                style={{ width: `${progressPercentage}%` }}
              />
            </div>
          </div>

          <button
            onClick={onUploadClick}
            className="text-sm text-blue-600 hover:text-blue-700 font-medium hover:underline"
          >
            Upload Evidence
          </button>
        </div>
      </div>
    </div>
  );
};

export default ManualEvidenceAreaCard;
